import { createSlice } from "@reduxjs/toolkit";

const initialKostState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  kostForEdit: undefined,
  kostForExport: []
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const kostSlice = createSlice({
  name: "kost",
  initialState: initialKostState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		kostFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		kostAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
		kostExportFetched: (state, action) => {
      const { entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.kostForExport = entities;
    },
    kostCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.kost.push(action.payload.kost);
    },
    kostDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.kost.filter(el => el.kost_id !== action.payload.id);
    },
    getKost: (state, action) => {
      state.actionsLoading = false;
      state.kostForEdit = action.payload.kostForEdit;
      state.error = null;
    },
    getExportKost: (state, action) => {
      state.actionsLoading = false;
      if(action.payload.kostForExport === undefined) {
        state.kostForExport = [];
      }else{
        state.kostForExport.push(action.payload.kostForExport);
      }
      state.error = null;
    },
    // updateProduct
    kostUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.kost = state.entities.kost.map(entity => {
        if (entity.kost_id === action.payload.kost.kost_id) {
          return action.payload.kost;
        }
        return entity;
      });
    },
  },
});
